export const GET_CHAT_MESSAGES_REQUEST = 'GET_CHAT_MESSAGES_REQUEST';
export const GET_CHAT_MESSAGES_SUCCESS = 'GET_CHAT_MESSAGES_SUCCESS';
export const GET_CHAT_MESSAGES_FAILURE = 'GET_CHAT_MESSAGES_FAILURE';

export const POST_MESSAGE_TO_CHAT_REQUEST = 'POST_MESSAGE_TO_CHAT_REQUEST';
export const POST_MESSAGE_TO_CHAT_SUCCESS = 'POST_MESSAGE_TO_CHAT_SUCCESS';
export const POST_MESSAGE_TO_CHAT_FAILURE = 'POST_MESSAGE_TO_CHAT_FAILURE';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const RESET_SCROLL_TO_BOTTOM = 'RESET_SCROLL_TO_BOTTOM';
export const RESET_CHAT = 'RESET_CHAT';
export const RELOAD_MESSAGES = 'RELOAD_MESSAGES';
